import { dayKey, fullDate } from '@app/utils';

/** The sprints with a period to report: the ones that ended before today, where today is a local day. */
export const closedSprintsOf = <T extends { endDate: Date | string }>(sprints: T[]): T[] => {
  const today = dayKey(new Date());

  return sprints.filter(sprint => fullDate(sprint.endDate) < today);
};
